/** 客服页皮肤：gameId → 配置，未命中则 common */

export const SUPPORT_THEME_BY_GAME_ID = {
  191: { theme: 'dark' },
  284: { theme: 'dark' },
  227: { theme: 'dark' },
  225: { theme: 'dark' },
  221: { theme: 'dark' },
  440: { theme: 'dark' },
  466: { theme: 'dark' },
  454: { theme: 'dark' },
  386: { theme: 'roworld' },
  456: { theme: 'roworld' }
};

/**
 * @param {string|number} gameId
 * @returns {{ theme: 'dark'|'roworld'|'common' }}
 */
export function getSupportThemeConfig(gameId) {
  return SUPPORT_THEME_BY_GAME_ID[+gameId] || { theme: 'common' };
}

/**
 * @param {string|number} gameId
 * @returns {'dark'|'roworld'|'common'}
 */
export function getSupportThemeClass(gameId) {
  return getSupportThemeConfig(gameId).theme;
}
